import { Component, Input } from '@angular/core';
import { InputOutputType, ModuleSpecification, UIProperty } from '@ca/core/models';
import { FileService } from '@ca/core/services';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy } from '@ngneat/until-destroy';
import { take, tap } from 'rxjs/operators';
import { ModuleSpecService } from './module-spec.service';

@UntilDestroy()
@Component({
    selector: 'ca-module-spec-generator',
    templateUrl: './module-spec-generator.component.html',
    styleUrls: ['./module-spec-generator.component.scss'],
    providers: [ModuleSpecService],
})
export class ModuleSpecGeneratorComponent {
    @Input() set moduleTitle(moduleTitle: string) {
        this._moduleTitle = moduleTitle;
    }
    @Input() set specification(spec: ModuleSpecification) {
        if (spec != null) {
            const specWithoutImage = this.removeImageTag(spec);
            this.moduleSpecificationService.setSpecification(specWithoutImage);
        }
    }

    get moduleTitle(): string {
        return this._moduleTitle;
    }

    specification$ = this.moduleSpecificationService.specification$;

    _moduleTitle: string;
    propertyDefinitionComplete: boolean = false;
    isFormValid: boolean = false;

    constructor(
        private fileService: FileService,
        private modalService: NgbActiveModal,
        private moduleSpecificationService: ModuleSpecService,
    ) {}

    dismiss(): void {
        this.modalService.dismiss();
    }

    handleFormValidityChanged(isFormValid: boolean): void {
        // setTimeout to prevent expressionChangedAfterChecked
        setTimeout(() => {
            this.isFormValid = isFormValid;
        });
    }

    addInputOutput(inputOutput: InputOutputType): void {
        this.moduleSpecificationService.addInputOutput(inputOutput, undefined, undefined, true);
    }

    removeInputOutput(res: { parameter: UIProperty; type: InputOutputType }): void {
        this.moduleSpecificationService.removeInputOutput(res.parameter, res.type, true);
    }

    next(): void {
        this.propertyDefinitionComplete = true;
        this.moduleSpecificationService.resetActiveProp();
    }

    previous(): void {
        this.propertyDefinitionComplete = false;
    }

    download(): void {
        this.specification$
            .pipe(
                take(1),
                tap(spec => {
                    this.fileService.downloadJSON(spec as ModuleSpecification, 'module_specification');
                }),
            )
            .subscribe();
    }

    setActiveProp(event: UIProperty | undefined): void {
        this.moduleSpecificationService.setActiveProp(event);
    }

    /**
     * 308601: Removes the "image" tag from specification.
     */
    private removeImageTag(specification: ModuleSpecification): ModuleSpecification {
        const specificationDeepCopy = JSON.parse(JSON.stringify(specification));

        if (specification.image != null) {
            delete specificationDeepCopy.image;
        }

        return specificationDeepCopy;
    }
}
